import { render, staticRenderFns } from "./OtsFlyoutComponent.vue?vue&type=template&id=63a67258&"
import script from "./OtsFlyoutComponent.vue?vue&type=script&lang=ts&"
export * from "./OtsFlyoutComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63a67258')) {
      api.createRecord('63a67258', component.options)
    } else {
      api.reload('63a67258', component.options)
    }
    module.hot.accept("./OtsFlyoutComponent.vue?vue&type=template&id=63a67258&", function () {
      api.rerender('63a67258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flyout/340th/OtsFlyoutComponent.vue"
export default component.exports